export function offerCalculatorReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    switch (action.type) {
        case "set_param": {
            const isBase = action.name === "finance_type" || action.name === "offer_type";
            const next = Object.assign(Object.assign({}, state), { user_change: action.name, user_param_change: isBase ? "" : action.name, changeSeq: state.changeSeq + 1 });
            if (action.name === "packages" && typeof action.value === "object") {
                next.packages = action.value;
            }
            else {
                next[action.name] = action.value;
            }
            return next;
        }
        case "set_code":
            return Object.assign(Object.assign({}, state), { code: action.code, user_change: "code", user_param_change: "code", changeSeq: state.changeSeq + 1 });
        case "reset_params":
            return Object.assign(Object.assign({}, state), { finance_type: state.bootstrap.defaultFinanceType, offer_type: state.bootstrap.defaultOfferType, contract_period: "", contribution: "", repurchase: "", mileage: "", packages: {}, user_change: "reset", user_param_change: "", changeSeq: state.changeSeq + 1 });
        case "price_request":
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false });
        case "price_success": {
            const config = action.payload.config;
            const fieldsByName = config.reduce((acc, field) => {
                acc[field.name] = field;
                return acc;
            }, {});
            const finance = fieldsByName.finance_type;
            const offerType = fieldsByName.offer_type;
            const period = fieldsByName.contract_period;
            const contribution = fieldsByName.contribution;
            const repurchase = fieldsByName.repurchase;
            const mileage = fieldsByName.mileage;
            const packagesField = fieldsByName.packages;
            const packages = {};
            if ((packagesField === null || packagesField === void 0 ? void 0 : packagesField.value) && typeof packagesField.value === "object") {
                Object.entries(packagesField.value).forEach(([id, val]) => {
                    if (String(val) === "1") {
                        packages[id] = "1";
                    }
                });
            }
            const lastParams = {
                code: action.payload.selected,
                finance_type: String((_a = finance === null || finance === void 0 ? void 0 : finance.value) !== null && _a !== void 0 ? _a : ""),
                offer_type: String((_b = offerType === null || offerType === void 0 ? void 0 : offerType.value) !== null && _b !== void 0 ? _b : ""),
                contract_period: String((_c = period === null || period === void 0 ? void 0 : period.value) !== null && _c !== void 0 ? _c : ""),
                contribution: String((_d = contribution === null || contribution === void 0 ? void 0 : contribution.value) !== null && _d !== void 0 ? _d : ""),
                repurchase: String((_e = repurchase === null || repurchase === void 0 ? void 0 : repurchase.value) !== null && _e !== void 0 ? _e : ""),
                mileage: String((_f = mileage === null || mileage === void 0 ? void 0 : mileage.value) !== null && _f !== void 0 ? _f : ""),
                packages: Object.keys(packages).join(","),
            };
            return Object.assign(Object.assign({}, state), { isLoading: false, isReady: true, error: false, priceData: action.payload, config, code: action.payload.selected, finance_type: String((_g = finance === null || finance === void 0 ? void 0 : finance.value) !== null && _g !== void 0 ? _g : state.finance_type), offer_type: String((_h = offerType === null || offerType === void 0 ? void 0 : offerType.value) !== null && _h !== void 0 ? _h : state.offer_type), contract_period: String((_j = period === null || period === void 0 ? void 0 : period.value) !== null && _j !== void 0 ? _j : state.contract_period), contribution: String((_k = contribution === null || contribution === void 0 ? void 0 : contribution.value) !== null && _k !== void 0 ? _k : state.contribution), repurchase: String((_l = repurchase === null || repurchase === void 0 ? void 0 : repurchase.value) !== null && _l !== void 0 ? _l : state.repurchase), mileage: String((_m = mileage === null || mileage === void 0 ? void 0 : mileage.value) !== null && _m !== void 0 ? _m : state.mileage), packages,
                lastParams });
        }
        case "price_failure":
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true });
        case "first_load_done":
            return Object.assign(Object.assign({}, state), { isFirstLoad: false });
        default:
            return state;
    }
}
/** Maps a comma-separated `packages` URL value (shared-link IDs) into the
 * selected-packages map the price request expects, e.g. "a,b" -> { a: "1", b: "1" }. */
function parsePackagesParam(value) {
    if (!value) {
        return {};
    }
    return value.split(",").reduce((acc, id) => {
        const trimmed = id.trim();
        if (trimmed) {
            acc[trimmed] = "1";
        }
        return acc;
    }, {});
}
export function createInitialState(bootstrap, urlOverrides) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        bootstrap,
        code: (_a = urlOverrides.code) !== null && _a !== void 0 ? _a : bootstrap.code,
        finance_type: (_b = urlOverrides.finance_type) !== null && _b !== void 0 ? _b : bootstrap.financeType,
        offer_type: (_c = urlOverrides.offer_type) !== null && _c !== void 0 ? _c : bootstrap.offerType,
        contract_period: (_d = urlOverrides.contract_period) !== null && _d !== void 0 ? _d : bootstrap.contractPeriod,
        contribution: (_e = urlOverrides.contribution) !== null && _e !== void 0 ? _e : bootstrap.contribution,
        repurchase: (_f = urlOverrides.repurchase) !== null && _f !== void 0 ? _f : bootstrap.repurchase,
        mileage: (_g = urlOverrides.mileage) !== null && _g !== void 0 ? _g : bootstrap.mileage,
        packages: parsePackagesParam(urlOverrides.packages),
        user_change: bootstrap.userChange || "initFromGet",
        user_param_change: "",
        changeSeq: 0,
        config: [],
        priceData: null,
        isLoading: true,
        isReady: false,
        isFirstLoad: true,
        lastParams: {},
        error: false,
    };
}
